/* 🤖 this file was generated by svg-to-ts */
export const emperorIconChatBubbleSquareQuestionMark: {
  name: 'chat_bubble_square_question_mark';
  data: string;
} = {
  name: 'chat_bubble_square_question_mark',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M2.99 24v-4h-1c-1.104 0-2-.9-2-2V9c0-1.104.89-2 2-2h13c1.1 0 2 .89 2 2v9c0 1.1-.9 2-2 2H8.32l-5.34 4Zm-1-15v9h3v2l2.66-2h7.334V9h-13Z"/><path d="M20.99 9h-2V6h1c1.1 0 2-.9 2-2 0-1.104-.9-2-2-2 -1.11 0-2 .89-2 2h-2c0-2.205 1.79-4 4-4 2.2 0 4 1.795 4 4 0 1.86-1.28 3.428-3 3.87v1.12Z"/><path d="M19.99 10a1 1 0 1 0 0 2 1 1 0 1 0 0-2Z"/></g></svg>`,
};
